<form class="link-form-container" [formGroup]="linkForm" (ngSubmit)="onSubmit()">
    <!-- Transfer title input -->
    <div class="input-container" (click)="inputClick($event)">
        <app-smash-input type="text" placeholder="{{ 'UPLOADER_LINK_FORM_PLACEHOLDER_TITLE' | translate }}"
            formControlName="title" (valueChange)="onTitleChange($event)"
            tooltipContent="{{'UPLOADER_LINK_FORM_LINK_TITLE_TOOLTIP' | translate}}"
            [disabled]="(uploadStatus$ |async) === 'Starting' || (uploadStatus$ |async) === 'Queued' || (uploadStatus$ |async) === 'QueueFinished'">
        </app-smash-input>
    </div>
    <!-- Link name input -->
    <div class="input-container" (click)="inputClick($event)">
        <app-smash-input type="text" prefix="fromsmash.com/" formControlName="customUrl"
            [error]="submitted && f.customUrl.errors || (uploadError$ | async)?.name === 'CustomUrlAlreadyInUseError'"
            tooltipContent="{{'UPLOADER_LINK_FORM_LINK_CUSTOM_URL_TOOLTIP' | translate:{domain: domain.domain} }}"
            [disabled]="(uploadStatus$ |async) === 'Starting' || (uploadStatus$ |async) === 'Queued' || (uploadStatus$ |async) === 'QueueFinished'">
        </app-smash-input>
    </div>
    <!-- Sender email input -->
    <div class="input-container" [ngClass]="{'hidden': !!identity?.username}" formGroupName="sender">
        <app-smash-input type="email" placeholder="{{ 'UPLOADER_LINK_FORM_PLACEHOLDER_YOUR_EMAIL' | translate }}"
            formControlName="email" [error]="submitted && senderEmailControls.errors"
            tooltipContent="{{'UPLOADER_LINK_FORM_RECEIVE_COPY_LINK_TOOLTIP' | translate}}"
            [readonly]="!!identity?.username" [disabled]="!!identity.username">
            <div *ngIf="submitted && senderEmailControls.errors" error>{{
                'UPLOADER_LINK_FORM_ALERT_MESSAGE_INCORRECT_EMAIL' | translate }}</div>
        </app-smash-input>
    </div>

    <div *ngIf="isAccessTrackingEnabled" class="input-container checkbox">
        <label [appSmashTooltip]="newTooltipTemplate" [autoPlacement]="true" placement="right" contentType="template"
            offset="45" theme="light" width="200">
            <div translate>UPLOADER_CONFIG_SMASH_SUBTITLE_DOWNLOAD_ACCESS_TRACKING</div>
            <div class="parameter-input checkbox">
                <app-smash-checkbox formControlName="accessTracking"></app-smash-checkbox>
            </div>
        </label>
    </div>

    <div *ngIf="f.customUrl.errors" class="error-message-link-already-exists" translate>UPLOADER_LINK_INVALID</div>
    <div *ngIf="(uploadError$ | async)?.name === 'CustomUrlAlreadyInUseError'"
        class="error-message-link-already-exists" translate>
        UPLOADER_LINK_ALREADY_EXISTS
    </div>
    <div *ngIf="showMessageDisabled" class="error-message-link-already-exists" translate>UPLOADER_LINK_DISABLED</div>
    <button type="submit" (click)="onSubmit(); false"></button>
</form>

<ng-template #newTooltipTemplate>
    <div class="tooltip-content">
        <div>{{'UPLOADER_CONFIG_SMASH_SUBTITLE_DOWNLOAD_ACCESS_TRACKING_HELP' | translate}}</div>
    </div>
</ng-template>